import Autocomplete, { type AutocompleteProps } from "@mui/material/Autocomplete";
import AppTextField from "./AppTextField";
import { APP_FORM_DEFAULTS } from "./constants";

type BaseProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = boolean | undefined,
  FreeSolo extends boolean | undefined = false,
> = Omit<AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>, "renderInput"> & {
  label: string;
  helperText?: string;
  renderInput?: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>["renderInput"];
};

/**
 * Standard MUI Autocomplete with AppTextField as the input (outlined, consistent sizing).
 * DisableClearable defaults to `boolean | undefined` so `disableClearable` props type-check
 * without forcing every call site to pass a generic.
 */
export default function AppAutocomplete<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = boolean | undefined,
  FreeSolo extends boolean | undefined = false,
>({
  label,
  helperText,
  size,
  fullWidth,
  renderInput,
  ...rest
}: BaseProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Autocomplete
      size={size ?? APP_FORM_DEFAULTS.size}
      fullWidth={fullWidth ?? APP_FORM_DEFAULTS.fullWidth}
      renderInput={
        renderInput ??
        ((params) => (
          <AppTextField
            {...params}
            label={label}
            helperText={helperText}
            margin={APP_FORM_DEFAULTS.margin}
            size={size ?? APP_FORM_DEFAULTS.size}
          />
        ))
      }
      {...rest}
    />
  );
}
